import { Siren, Phone } from "lucide-react";
import { SITE } from "../lib/site";

export default function EmergencyBanner() {
  return (
    <div data-testid="emergency-banner" className="bg-[var(--ac-red)] text-white">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-2 flex items-center justify-between gap-3 text-[11px] md:text-sm">
        <a
          href={`tel:${SITE.phoneE164}`}
          className="flex items-center gap-2 uppercase font-bold tracking-[0.14em] md:tracking-[0.18em] min-w-0"
          data-testid="emergency-banner-call"
          aria-label={`Call ${SITE.phone} for emergency service`}
        >
          <Siren className="w-3.5 h-3.5 md:w-4 md:h-4 shrink-0" />
          <span className="truncate">
            <span className="hidden sm:inline">24/7 Emergency Lifting — Central Florida</span>
            <span className="sm:hidden">24/7 Emergency Service</span>
          </span>
        </a>
        <a
          href={`tel:${SITE.phoneE164}`}
          className="inline-flex items-center gap-1.5 font-mono-data uppercase tracking-wider hover:underline shrink-0"
        >
          <Phone className="w-3.5 h-3.5 md:w-4 md:h-4" />
          <span className="whitespace-nowrap">{SITE.phone}</span>
        </a>
      </div>
    </div>
  );
}
